module.exports = __webpack_public_path__ + "rickandmortylogo.ca355fb.png";